// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".h-dynamic-air-package__dialog .v-stack-dialog__content{color:#000!important;background:#fff!important}.h-dynamic-air-package__iframe-wrapper{width:928px;max-width:calc(100vw - 80px);height:548px;max-height:calc(100vh - 160px)}.h-dynamic-air-package__iframe{width:100%;height:100%}", ""]);
// Exports
module.exports = exports;
